module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/desktop_9000c3.jpg";